
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 31 31","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.25 29.4a14.1 14.1 0 01-13.033-8.714 14.123 14.123 0 013.06-15.384 14.104 14.104 0 0124.08 9.987 14.136 14.136 0 01-4.137 9.974 14.118 14.118 0 01-9.97 4.137zm0-25.88a11.753 11.753 0 00-10.864 7.259A11.771 11.771 0 006.93 23.601a11.755 11.755 0 0020.074-8.312 11.78 11.78 0 00-3.444-8.317 11.766 11.766 0 00-8.31-3.452z"}}),_c('path',{attrs:{"d":"M11.219 14.111a1.763 1.763 0 10-.001-3.526 1.763 1.763 0 00.001 3.526zM19.447 14.111a1.763 1.763 0 10-.001-3.526 1.763 1.763 0 00.001 3.526z"}}),_c('rect',{attrs:{"x":"8.036","y":"19.159","width":"14.595","height":"2.038","rx":"1.019"}})])
          )
        }
      }
    